<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div id="main">
        <section class="artWorkCateTop">
          <div v-if="this.$route.path === '/organizer'" class="artWorkCateTopTitle">
            <div class="inner4">
              <h1>主催者企画</h1>
              <p class="titleSub">Exhibitions by Organizer</p>
            </div><!-- /inner4-->
          </div><!-- /photographersListTitle-->

          <div class="artWorkCateTopBody">
            <div class="inner2">

              <div v-if="this.$route.path === '/organizer'" class="listBlock">
                <template v-for="category of ['Twitterフォトコンテスト', 'Japan Travel Gallery Photo Contest 2021', 'Weibo']">
                  <div :key="category">
                    <h2>{{category}}</h2>
                      
                      <template v-if="category == 'Twitterフォトコンテスト'">
                        <template v-for="subCategory of ['スナップ部門', 'ポスター部門', 'ポートレート部門']">
                          <div :key="subCategory">
                            <h3>{{subCategory}}</h3>
                              <div class="listBlockInner twitterBlock">
                              <div v-if="winnerListBySubCategory(subCategory).length <= 0" class="comingSoon">
                                Coming Soon
                              </div>
                              <template v-for="(winner, index) of winnerListBySubCategory(subCategory)">
                                <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                                  <div class="thumbnailImg">
                                      <router-link :to="workUrl(winner)">
                                        <img :src="winner.mainImageUrl" :alt="winner.mainImageTitle" />
                                      </router-link>
                                  </div>
                                  <h3><router-link :to="workUrl(winner)">{{ winner.name }}</router-link></h3>
                                </div>
                              </template>
                            </div>
                          </div>
                        </template>
                      </template>
                    <template v-else>
                      <div class="listBlockInner">
                        <template v-for="(winner, index) of winnerListByCategory(category)">
                          <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                            <div class="thumbnailImg">
                                <router-link :to="workUrl(winner)">
                                  <img :src="winner.mainImageUrl" :alt="winner.mainImageTitle" />
                                </router-link>
                            </div>
                            <h3><router-link :to="workUrl(winner)">{{ winner.name }}</router-link></h3>
                          </div>
                        </template>
                      </div><!-- /listBlockInner-->
                    </template>

                  </div>
                </template>
              </div><!-- /listBlock-->
            </div><!-- /inner2-->
          </div><!-- /photographersListBody-->
        </section><!-- /photobook-->

      </div><!-- /main-->
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    getArtworksCode (winner) {
      if (!this.awardTypeCode || !winner) return
      return this.awardTypeCode[winner.awardType]
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    awardTypeList () {
      if (this.$route.path === '/organizer') {
        return [11, 12, 13, 14, 15, 16]
      }
    },
    winnerList (type) {
      return this.winners.filter((winner) => { return winner.awardType === type })
    },
    winnerListByCategory (category) {
      return this.winners.filter((winner) => {
        if (category.indexOf('Twitter') >= 0) {
          return [11, 12, 13].indexOf(winner.awardType) >= 0
        } else if (category.indexOf('Weibo') >= 0) {
          return winner.awardType === this.EnumAwardTypeWeibo
        } else {
          return winner.awardType === this.EnumAwardTypeJtg
        }
      })
    },
    winnerListBySubCategory (subCategory) {
      return this.winners.filter((winner) => {
        if (subCategory.indexOf('スナップ') >= 0) {
          return winner.awardType === this.EnumAwardTypeTwitterSnap
        } else if (subCategory.indexOf('ポスター') >= 0) {
          return winner.awardType === this.EnumAwardTypeTwitterPoster
        } else {
          return winner.awardType === this.EnumAwardTypeTwitterPortrait
        }
      })
    },
    workUrl (winner) {
      let path = ''
      if (winner.awardType == this.EnumAwardTypeTwitterPoster) {
        path = `/organizer/twitter/poster/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeTwitterSnap) {
        path = `/organizer/twitter/snap/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeTwitterPortrait) {
        path = `/organizer/twitter/portrait/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeJtg) {
        path = `/organizer/jtg/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeWeibo) {
        path = `/organizer/weibo/${winner.id}`
      }
      return path
    },
  },
  created () {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
